<template>
  <div class="grid-container content-page">
    <div class="title-page"><h4>Carnet de bord</h4></div>
    <div class="grid-x grid-margin-x">
      <event-calendar />

      <!-- TODO passer les fiches en JSON -->
      <item-fiche class="small-12 medium-6 large-4 small-order-4 cell" :lien="fiche.url || 'fiche_medicale'" :titlebox="fiche.title" :type-item="fiche.type">{{ fiche.content }}</item-fiche>

      <div class="small-12 medium-12 large-4 small-order-1 cell center">
        <parent-menu />

        <div class="box-edit-avatar">
          <div v-if="currentUser.avatar === 'body-blue eyeAccessory-none eye-want hat-none mouth-bigSmile neck-none nose-none'" class="bubble edit-avatar right txtleft" :class="{on: currentUser.avatar === 'body-blue eyeAccessory-none eye-want hat-none mouth-bigSmile neck-none nose-none'}">
            <span>
              <div>Pensez à modifier votre avatar.</div>
            </span>
          </div>

          <avatar-profil class="small" :user="currentUser"></avatar-profil>
        </div>
      </div>
    </div>

    <child-tracking />

    <div class="grid-x grid-margin-x">
      <div class="small-12 medium-12 large-6 cell">
        <div class="box-dot">
          <div class="content txt">
            <title-box color="red" icon-name="fa-gamepad">Jeu Fil Rouge</title-box>
            <div class="txt">
              <p><strong>Le jeu Fil Rouge</strong> est en cours </br> de développement actuellement</p>
              <bouton href="fil_rouge">En savoir plus</bouton>
            </div>
          </div>
        </div>
      </div>

      <div class="small-12  medium-12 large-6 cell">
        <div class="box-dot">
          <div class="content">
            <title-box color="green" icon-name="fa-users">La Communauté* de {{ childName }}</title-box>
            <div class="content-badges">
              <item-community v-for="user in community" :user="user" class="proche"></item-community>
            </div>
          </div>
        </div>
      </div>
    </div>

    <badges-list :for="subaccounts.child" :badges_ids="badges" />
    <medical-team :for="subaccounts.child" :caregivers="subaccounts.caregivers"  />

  </div>
</template>

<script>
  import { mapGetters, mapActions, mapState } from 'vuex'
  import { formatDate } from '@/functions'

  import Bouton from '@/components/Bouton'
  import ItemBadge from '@/components/ItemBadge'
  import ItemTeam from '@/components/ItemTeam'
  import ItemCommunity from '@/components/ItemCommunity'
  import ItemNotif from '@/components/ItemNotif'
  import ItemFiche from '@/components/ItemFiche'
  import TitlePage from '@/components/TitlePage'
  import TitleBox from '@/components/TitleBox'
  import TitleFiche from '@/components/TitleFiche'
  import AvatarProfil from '@/components/AvatarProfil'
  import IfUser from '@/components/IfUser'

  import MedicalTeam from './dashboardComponents/MedicalTeam'
  import BadgesList from './dashboardComponents/BadgesList'
  import ChildTracking from './dashboardComponents/ChildTracking'
  import ParentMenu from './dashboardComponents/ParentMenu'
  import EventCalendar from './dashboardComponents/EventCalendar'
  import EventTimeline from './dashboardComponents/EventTimeline'

  export default {
    components: {AvatarProfil, Bouton, ItemBadge, ItemTeam, ItemCommunity, ItemNotif, ItemFiche, TitlePage, TitleFiche, TitleBox, MedicalTeam, BadgesList, ChildTracking, ParentMenu, EventCalendar, EventTimeline, IfUser },
    computed: {
      ...mapState(['subaccounts']),
      ...mapGetters(['completeName', 'childName', 'badges']),
      currentUser() {
        return this.$store.state.me
      },
      community() {
        let relatives = this.subaccounts.relatives.concat(this.subaccounts.friends)
        if (this.subaccounts.child) {
          relatives = relatives.concat(this.subaccounts.child)
        }
        return relatives
      }
    },
    beforeRouteEnter(to, from, next){
      next(vm => {
        if(vm.$store.state.me.account_type !== 'parent'){
          next({ name: 'dashboard-' + vm.$store.state.me.account_type });
        } else if (!vm.$store.state.subaccounts.child) {
          next({ name: 'PostFirstSignIn' });
        } else {
          next();
        }
      })
    },
    data() {
      let fichesData = [
        {
          title: 'L’aventure de Jules',
          type: 'bd',
          content: `Une bande-dessinée simple pour comprendre le quotidien de Jules et son chemin vers la guérison`,
          tags: ['leucemie'],
          url: 'http://www.source-vive.org/Enfants/AventuredeJules.pdf'
        },
        {
          url: 'https://www.youtube.com/watch?time_continue=458&v=bBC4qro2vI0',
          title: 'Mission Spécial Charly est malade',
          type: 'video',
          tags: ['leucemie'],
          content: `Léo et Nina naviguent dans le corps de leur ourson Charly pour découvrir de quelle maladie il souffre et comment le soigner`
        },
        {
          url: 'https://www.ligue-cancer.net/sites/default/files/brochures/leucemies.pdf',
          title: 'Les Leucémies (livret, La Ligue contre le Cancer).',
          type: 'article',
          tags: ['leucemie'],
          content: `Un livret expliquant brièvement les différents types de leucémies et le principe des traitements`
        },
        {
          url: 'https://www.fondation-arc.org/support-information/brochure-leucemies-enfant',
          title: 'Les leucémies de l’enfant, Comprendre et Agir (livret. Fondation ARC).',
          type: 'article',
          tags: ['leucemie'],
          content: `Symptomes, facteurs de risque, diagnostic, traitement, vie quotidienne. Ce livret d'informations traitent des grandes questions concernant les leucémies des enfants`
        },
        {
          url: 'https://www.e-cancer.fr/Expertises-et-publications/Catalogue-des-publications/Mon-enfant-a-un-cancer-comprendre-et-etre-aide',
          title: 'Mon enfant a un cancer : comprendre et être aidé',
          type: 'article',
          tags: ['leucemie'],
          content: `Un guide complet de la prise en charge d'un enfant malade à destination de ses parents`
        },
        {
          url: 'http://www.choisirlespoir.fr/wp-content/uploads/2018/06/pour_nous_frere_et_soeur.pdf',
          title: 'Pour nous frères et sœurs, pas facile à vivre: Arthur a un cancer',
          type: 'bd',
          tags: ['leucemie'],
          content: `Une bande-dessinée destinée à la fratrie qui explique la leucémie avec des mots simples`
        },
        {
          url: 'http://lesamisdemikhy.org/wp-content/uploads/2017/09/Livret-Enfant-Les-Petits-Citoyens.pdf',
          title: `Et si on s'parlait du cancer ?`,
          type: 'bd',
          tags: ['leucemie'],
          content: `'Le cancer c'est quoi ? C'est contagieux ? Ça se soigne ?'. Tout pour comprendre ce que signifie ce mot et pouvoir en parler entre copains grâce à cette bande dessinée`
        }
      ]

      let fiche = fichesData[Math.floor(Math.random() * fichesData.length)]

      return {
        fiche
      }
    },
    methods: {
      formatDate
    }
  }
</script>
